import i18n from 'helpers/i18n';
import messages from 'components/Password/messages';

// Informed by Okta policy for not including username in password
// https://support.okta.com/help/s/article/cannot-use-any-part-of-username-in-password?language=en_US
export function getPolicyParts(value: string): string[] {
  return value
    .toLowerCase()
    .split(/[^a-z0-9]+/i)
    .filter(part => part.length >= 4);
}

export interface ValidatePasswordOptions {
  firstName?: string;
  lastName?: string;
  email?: string;
}

export function validatePassword(
  value: string,
  { firstName = '', lastName = '', email = '' }: ValidatePasswordOptions = {}
): true | string {
  const failures: string[] = [];
  const emailParts = getPolicyParts(email);

  if (value.length < 12) failures.push(i18n.ft(messages.lengthMin));
  if (value.length > 64) failures.push(i18n.ft(messages.lengthMax));
  if (
    firstName !== '' &&
    value.toLowerCase().includes(firstName.toLowerCase())
  ) {
    failures.push(i18n.ft(messages.noFirstName));
  }
  if (lastName !== '' && value.toLowerCase().includes(lastName.toLowerCase())) {
    failures.push(i18n.ft(messages.noLastName));
  }
  if (
    emailParts.length > 0 &&
    emailParts.some(part => value.toLowerCase().includes(part))
  ) {
    failures.push(i18n.ft(messages.noEmail));
  }

  return failures.length === 0
    ? true
    : `${i18n.ft(messages.passwordRequirementsNotMet)} ${failures.join('. ')}`;
}

export function validatePasswordConfirmation(
  value: string,
  password: string
): true | string {
  if (!value) return i18n.ft(messages.pleaseConfirm);
  if (value !== password) return i18n.ft(messages.passwordsDoNotMatch);
  return true;
}
